function timeAgo(input, opts = {}) {
  const { now = Date.now(), short = false } = opts;

  const nowMs = now instanceof Date ? now.getTime() : Number(now);
  const date = parseToDate(input);
  if (!date) return ''; // or '—'

  const diffMs = nowMs - date.getTime();
  const future = diffMs < 0;
  const absSec = Math.floor(Math.abs(diffMs) / 1000);

  if (absSec < 5) {
    return short ? (future ? 'now' : 'now') : (future ? 'in a moment' : 'Just now');
  }
  if (absSec < 60) return fmt(absSec, 'second', short, future);

  const min = Math.floor(absSec / 60);
  if (min < 60) return fmt(min, 'minute', short, future);

  const hr = Math.floor(min / 60);
  if (hr < 24) return fmt(hr, 'hour', short, future);

  const day = Math.floor(hr / 24);
  return fmt(day, 'day', short, future);
}

/** Parse Date | number | string (ISO or MySQL DATETIME) into Date. */
function parseToDate(input) {
  if (input instanceof Date) return input;
  if (typeof input === 'number') return new Date(input);

  if (typeof input === 'string') {
    // MySQL DATETIME "YYYY-MM-DD HH:mm:ss" (no timezone)
    if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}$/.test(input)) {
      return new Date(input.replace(' ', 'T')); // treated as local time
    }
    const d = new Date(input); // ISO recommended
    if (!isNaN(d)) return d;
  }
  return null;
}

/** Format a unit with pluralization and "ago"/"in" handling. */
function fmt(value, unit, short, future) {
  if (short) {
    const code = unit === 'second' ? 's' : unit === 'minute' ? 'm' : unit === 'hour' ? 'h' : 'd';
    return future ? `in ${value}${code}` : `${value}${code} ago`;
  }
  const label = value === 1 ? unit : `${unit}s`;
  return future ? `in ${value} ${label}` : `${value} ${label} ago`;
}

// CommonJS export (Node / many bundlers)
module.exports = { timeAgo };

// If you use ESM, you can also do:
// export { timeAgo };
// export default timeAgo;
